import axios from 'axios';
import { DEBUG, ERROR, INFO, WARN } from './constants';
import { auth } from './firebase-config';
import { toHash } from 'helpers/hash';
import { IS_EMULATOR_MODE } from '../constants';

type LoggerType = 'info' | 'debug' | 'warn' | 'error';

class Logger {
    baseUrl: string;
    type: LoggerType;
    constructor(type: LoggerType) {
        this.baseUrl = process.env.REACT_APP_LOGGER_URL ?? '';
        // this.baseUrl = 'http://localhost:5000/df-ai-assistant-dev-2b18/us-central1/addLog';
        this.type = type;
    }

    async saveLogs(level: string, message: string, functionAction: string) {
        // Skip logging in emulator environment
        if (IS_EMULATOR_MODE || this.baseUrl === '' || window.location.hostname === 'localhost') {
            console.log(`[${this.type}] ${message} (${functionAction})`);
            return;
        }

        try {
            const res = await axios.post(this.baseUrl, {
                type: this.type,
                message,
                level,
                functionAction,
                userId: toHash(auth?.currentUser?.uid ?? 'no-user'),
            });
            return res;
        } catch (err) {
            console.log(err);
        }
    }

    async critical(message: string, functionAction: string) {
        try {
            const level = 'critical';
            const res = await this.saveLogs(level, message, functionAction);
            return res;
        } catch (err) {
            console.error(err);
            return null;
        }
    }
    async mediumError(message: string, functionAction: string) {
        try {
            const level = 'medium error';
            const res = await this.saveLogs(level, message, functionAction);
            return res;
        } catch (err) {
            console.error(err);
            return null;
        }
    }
    async low(message: string, functionAction: string) {
        try {
            const level = 'low';
            const res = await this.saveLogs(level, message, functionAction);
            return res;
        } catch (err) {
            console.error(err);
            return null;
        }
    }
}

export const infoLogger = new Logger(INFO);
export const debugLogger = new Logger(DEBUG);
export const warnLogger = new Logger(WARN);
export const errorLogger = new Logger(ERROR);
